import { render, staticRenderFns } from "./topicDetailItem.vue?vue&type=template&id=479daf01&scoped=true"
import script from "./topicDetailItem.vue?vue&type=script&lang=js"
export * from "./topicDetailItem.vue?vue&type=script&lang=js"
import style0 from "./topicDetailItem.vue?vue&type=style&index=0&id=479daf01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479daf01",
  null
  
)

export default component.exports